import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Distributor.Find.IRequest;
type Response = Api.Core.Distributor.Find.IResponse;
type Headers = Api.Core.Distributor.Find.IHeaders;
const url = '/api/Sales/Distributor/:id';
export default async function distributorFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
